export const PLAN_SERVICES_GET_DATA = 'PLAN_SERVICES_GET_DATA'
export const PLAN_SERVICES_GET_DATA_SUCCESS = 'PLAN_SERVICES_GET_DATA_SUCCESS'
export const PLAN_SERVICES_GET_DATA_FAILURE = 'PLAN_SERVICES_GET_DATA_FAILURE'

export const PLAN_SERVICES_SEND = 'PLAN_SERVICES_SEND'
export const PLAN_SERVICES_SEND_SUCCESS = 'PLAN_SERVICES_SEND_SUCCESS'
export const PLAN_SERVICES_SEND_FAILURE = 'PLAN_SERVICES_SEND_FAILURE'

export const PLAN_SERVICES_BY_USER = 'PLAN_SERVICES_BY_USER'
export const PLAN_SERVICES_BY_USER_SUCCESS = 'PLAN_SERVICES_BY_USER_SUCCESS'
export const PLAN_SERVICES_BY_USER_FAILURE = 'PLAN_SERVICES_BY_USER_FAILURE'

export const PLAN_SERVICES_BY_USER_UPDATE = 'PLAN_SERVICES_BY_USER_UPDATE'
export const PLAN_SERVICES_BY_USER_SUCCESS_UPDATE = 'PLAN_SERVICES_BY_USER_SUCCESS_UPDATE'
export const PLAN_SERVICES_BY_USER_FAILURE_UPDATE = 'PLAN_SERVICES_BY_USER_FAILURE_UPDATE'

export const UPDATE_PLAN_LINK_GENERATE = 'UPDATE_PLAN_LINK_GENERATE'
export const UPDATE_PLAN_LINK_GENERATE_SUCCESS = 'UPDATE_PLAN_LINK_GENERATE_SUCCESS'
export const UPDATE_PLAN_LINK_GENERATE_ERROR = 'UPDATE_PLAN_LINK_GENERATE_ERROR'

export const REDUCE_PLAN = 'REDUCE_PLAN'
export const REDUCE_PLAN_SUCCESS = 'REDUCE_PLAN_SUCCESS'
export const REDUCE_PLAN_ERROR = 'REDUCE_PLAN_ERROR'

